import React, { FunctionComponent } from "react";
import { IIconProps } from "./icon";

export const RecommendationsIcon: FunctionComponent<IIconProps> = (props) => {
  const { color, outlined, ...rest } = props;
  return (
    <svg width="52px" height="52px" viewBox="0 0 52 52" version="1.1" {...rest}>
      <g
        id="Symbols-Recommendations"
        stroke={color}
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <g id="RecommendationsIcon" stroke={color} strokeWidth="3">
          <path d="M19.048,15.3050667 C22.9212759,19.3159852 28.8722083,20.5119334 33.9943111,18.3088" />
          <path d="M17.9333333,19.4 C17.9333333,23.855097 21.544903,27.4666667 26,27.4666667 C30.455097,27.4666667 34.0666667,23.855097 34.0666667,19.4 C34.0666667,14.944903 30.455097,11.3333333 26,11.3333333 C21.544903,11.3333333 17.9333333,14.944903 17.9333333,19.4 Z" />
          <path d="M4,15.7352889 L4,6.93333333 C4,5.31329807 5.31329807,4 6.93333333,4 L15.7333333,4" />
          <path d="M48,15.7352889 L48,6.93333333 C48,5.31329807 46.6867019,4 45.0666667,4 L36.2666667,4" />
          <path d="M4,36.2666667 L4,45.0666667 C4,46.6867019 5.31329807,48 6.93333333,48 L15.7333333,48" />
          <path d="M48,36.2666667 L48,45.0666667 C48,46.6867019 46.6867019,48 45.0666667,48 L36.2666667,48" />
          <path
            d="M38.3923556,40.2 C36.5527926,34.9302002 31.5816469,31.4001905 26,31.4001905 C20.4183531,31.4001905 15.4472074,34.9302002 13.6076444,40.2"
            id="Path"
          />
        </g>
      </g>
    </svg>
  );
};
